import { ref, ssrRef } from '@nuxtjs/composition-api';
import { useCategoryContent } from '~/modules/catalog/category/components/cms/useCategoryContent';
import {
  useCategory,
} from '~/composables';

export const useCategoryContentUI = () => {
  const { getContentData } = useCategoryContent();
  const { loadCategoryMeta } = useCategory();

  const cmsContent = ref('');
  const isShowCms = ref(false);
  const isShowPage = ref(false);
  const isShowProducts = ssrRef(false);
  const categoryMeta = ref(null);

  const fetchContent = async (categoryUid) => {
    const [content, categoryMetaData] = await Promise.all([
      getContentData(categoryUid as string),
      loadCategoryMeta({ category_uid: categoryUid }),
    ]);

    categoryMeta.value = categoryMetaData;
    cmsContent.value = content?.cmsBlock?.content ?? '';
    isShowCms.value = content.isShowCms;
    isShowProducts.value = content.isShowProducts;
    isShowPage.value = content.isShowPage;
  };

  return {
    fetchContent,
    categoryMeta,
    cmsContent,
    isShowCms,
    isShowProducts,
    isShowPage,
  };
};
